import { useEffect, useMemo, useState } from 'react'

import { debounce } from 'lodash'

export default function useDebouncedValue<T>(value: T, delayMs: number): T {
    const [debouncedValue, setDebouncedValue] = useState(value)

    const setDebounced = useMemo(
        () =>
            debounce(
                (nextValue: T) => setDebouncedValue(() => nextValue),
                delayMs,
            ),
        [delayMs],
    )

    useEffect(() => {
        setDebounced(value)
    }, [value, setDebounced])

    useEffect(() => () => setDebounced.cancel(), [setDebounced])

    return debouncedValue
}
